module.exports = "<div class=\"row\">\n  <my-input class=\"col s6\"\n    ng-model=\"myDisposition.workshop\"\n    my-options=\"fieldsOptions.workshop\"\n    enable-validator=\"enableValidator\">\n  </my-input>\n\n  <my-date class=\"col s6\"\n    ng-model=\"myDisposition.date\"\n    my-options=\"fieldsOptions.dispositionDate\"\n    enable-validator=\"enableValidator\">\n  </my-date>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/wagon/directives/forms/myDispositionForm.html
// module id = 1109
// module chunks = 0